import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  UrlTree,
} from '@angular/router';
import { filter, map, Observable, withLatestFrom } from 'rxjs';

import { Store } from '@ngrx/store';

import { PromoBase } from '../models/promo';
import * as actions from '../store/actions/promo';
import { getPromos, promosReady } from '../store/selectors/promo';

@Injectable()
export class PromoGuard implements CanActivate {
  protected _promos$: Observable<PromoBase[]> = this._store.select(getPromos);
  protected _promosReady$ = this._store.select(promosReady);

  constructor(protected _router: Router, protected _store: Store) {}

  public canActivate(
    route: ActivatedRouteSnapshot,
  ): Observable<boolean | UrlTree> {
    return this._promosReady$.pipe(
      filter((r) => !!r),
      withLatestFrom(this._promos$),
      map(([, promos]) => {
        const promo = promos.find(
          (promo) => promo.name === route.data?.['promo'],
        );

        if (!promo) {
          return this._router.createUrlTree(['/404']);
        }

        this._selectAction(promo.name);

        return true;
      }),
    );
  }

  protected _selectAction(name: string): void {
    this._store.dispatch(actions.SelectPromo(name));
  }
}
